module.exports = __webpack_public_path__ + "img/bankverifi.bb27127f.svg";